import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=d297d576&scoped=true"
import script from "./EducationDetails.vue?vue&type=script&lang=js"
export * from "./EducationDetails.vue?vue&type=script&lang=js"
import style0 from "./EducationDetails.vue?vue&type=style&index=0&id=d297d576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d297d576",
  null
  
)

export default component.exports